module.exports = __webpack_public_path__ + "static/media/bridge-medium.c8ce50e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/trueBridge/bridge-medium.png
// module id = 61
// module chunks = 0